import {useCallback, useState} from 'react';

import {reconstructRangeFilterState} from '../filterProcessor.util';
import {FilterOptionProps} from '../MyTeamsContent.types';

type Props = {
  rankOptions?: FilterOptionProps[];
  newCoachesOptions?: FilterOptionProps[];
  fibcOptions?: FilterOptionProps[];
  bonusOptions?: FilterOptionProps[];
  filtersRedux: any;
  updateCurrentTabFilters: (filters: any) => void;
};

export const useMyTeamsFilterModal = ({
  rankOptions,
  newCoachesOptions,
  fibcOptions,
  bonusOptions,
  filtersRedux,
  updateCurrentTabFilters,
}: Props) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [clickedFilterType, setClickedFilterType] = useState<string>('');
  const [applyFilter, setApplyFilter] = useState(false);

  const openModal = useCallback(
    (filterType: string) => {
      setModalVisible(true);
      setClickedFilterType(filterType);
      setApplyFilter(false);

      const rankOptionsFilter = rankOptions?.filter(
        rankItem => rankItem.selected === true,
      );

      const NewCoachesFilter = newCoachesOptions?.find(
        NewCoachesItems => NewCoachesItems.selected === true,
      );

      const FIBCOptionsFilter = fibcOptions?.find(
        FIBCItem => FIBCItem.selected === true,
      );

      const bonusOptionsFilter = bonusOptions?.filter(b => b.selected);

      // Range filters reconstruction
      const rangeFilters = ['fqv', 'filterRange', 'newCoachesSponsored'];

      const reconstructed = Object.fromEntries(
        rangeFilters.map(key => [
          key,
          reconstructRangeFilterState(filtersRedux, key),
        ]),
      );

      /* WithoutFilter:
      If the user selects a filter and then closes the popover without clicking
      "Apply Filters", and subsequently reopens the popover, we display the
      previously applied filters.
      */
      updateCurrentTabFilters({
        rankWithoutFilter: rankOptionsFilter,
        newCoachesWithoutFilter: NewCoachesFilter,
        fibcWithoutFilter: FIBCOptionsFilter,
        fqvWithoutFilter: reconstructed.fqv,
        filterRangeWithoutFilter: reconstructed.filterRange,
        newCoachesSponsoredWithoutFilter: reconstructed.newCoachesSponsored,
        bonusWithoutFilter: bonusOptionsFilter,
      });
    },
    [
      rankOptions,
      newCoachesOptions,
      fibcOptions,
      bonusOptions,
      filtersRedux,
      updateCurrentTabFilters,
    ],
  );

  return {
    modalVisible,
    setModalVisible,
    clickedFilterType,
    applyFilter,
    setApplyFilter,
    openModal,
  };
};
